<div class="loading">
    <div></div>
    <h4 *ngIf="message">{{ message | translate }}</h4>
  </div>